
import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, UserRole } from '@/stores/authStore';

const Login = () => {
  const { isAuthenticated, login } = useAuthStore();
  const [selectedRole, setSelectedRole] = useState<UserRole>('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const roles: { value: UserRole; label: string }[] = [
    { value: 'admin', label: 'System Admin' },
    { value: 'ceo', label: 'CEO' },
    { value: 'director', label: 'Director' },
    { value: 'operations_head', label: 'Operations Head' },
    { value: 'ho_manager', label: 'HO Manager' },
    { value: 'sales_head', label: 'Sales Head' },
    { value: 'regional_manager', label: 'Regional Manager' },
    { value: 'manager_pobs', label: 'Manager POBS' },
    { value: 'branch_manager', label: 'Branch Manager' },
    { value: 'store_manager', label: 'Store Manager' },
    { value: 'manager', label: 'General Manager' },
    { value: 'sales', label: 'Sales Executive' },
    { value: 'qc', label: 'Quality Control' },
    { value: 'finance', label: 'Finance' },
    { value: 'customer', label: 'Customer' },
  ];

  const users = [
    { role: 'ceo', name: 'Rajesh Kumar', password: 'Admin@123' },
    { role: 'director', name: 'Priya Sharma', password: 'Admin@123' },
    { role: 'operations_head', name: 'Amit Patel', password: 'Admin@123' },
    { role: 'ho_manager', name: 'Sunita Gupta', password: 'Admin@123' },
    { role: 'sales_head', name: 'Vikram Singh', password: 'Admin@123' },
    { role: 'regional_manager', name: 'Neha Agarwal', password: 'Admin@123' },
    { role: 'manager_pobs', name: 'Rohit Mehta', password: 'Admin@123' },
    { role: 'branch_manager', name: 'Kavita Joshi', password: 'Admin@123' },
    { role: 'store_manager', name: 'Deepak Yadav', password: 'Admin@123' },
    { role: 'general_manager', name: 'Anita Verma', password: 'Admin@123' },
    { role: 'sales_executive', name: 'Ravi Kumar', password: 'Admin@123' },
    { role: 'quality_control', name: 'Pooja Reddy', password: 'Admin@123' },
    { role: 'finance', name: 'Suresh Iyer', password: 'Admin@123' },
    { role: 'system_admin', name: 'System Admin', password: 'Admin@123' },
    { role: 'customer', name: 'Customer User', password: 'Admin@123' },
    { role: 'vendor', name: 'Vendor User', password: 'Admin@123' },
  ];

  const handleLogin = () => {
    const success = login(selectedRole, password);
    if (!success) {
      setError('Invalid password. Please try again.');
    } else {
      setError('');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-primary)]/80 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[var(--color-primary)] rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-gem-line text-white text-2xl"></i>
          </div>
          <h1 className="text-3xl font-bold text-[var(--color-primary)]" style={{ fontFamily: 'Pacifico, serif' }}>
            Prince
          </h1>
          <p className="text-gray-600 mt-2">Jewelry Management System</p>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Role
            </label>
            <select
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 pr-8"
              required
            >
              <option value="">Select Role</option>
              <option value="ceo">CEO - Rajesh Kumar</option>
              <option value="director">Director - Priya Sharma</option>
              <option value="operations_head">Operations Head - Amit Patel</option>
              <option value="ho_manager">HO Manager - Sunita Gupta</option>
              <option value="sales_head">Sales Head - Vikram Singh</option>
              <option value="regional_manager">Regional Manager - Neha Agarwal</option>
              <option value="manager_pobs">Manager POBS - Rohit Mehta</option>
              <option value="branch_manager">Branch Manager - Kavita Joshi</option>
              <option value="store_manager">Store Manager - Deepak Yadav</option>
              <option value="general_manager">General Manager - Anita Verma</option>
              <option value="sales_executive">Sales Executive - Ravi Kumar</option>
              <option value="quality_control">Quality Control - Pooja Reddy</option>
              <option value="finance">Finance - Suresh Iyer</option>
              <option value="system_admin">System Admin - System Admin</option>
              <option value="customer">Customer - Customer User</option>
              <option value="vendor">Vendor - Vendor User</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[var(--color-primary)] focus:border-transparent"
              onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
            />
          </div>

          {error && (
            <div className="text-red-600 text-sm text-center">
              {error}
            </div>
          )}

          <button
            onClick={handleLogin}
            className="w-full bg-[var(--color-primary)] text-white py-3 px-4 rounded-lg font-medium hover:bg-[var(--color-primary)]/90 transition-colors whitespace-nowrap cursor-pointer"
          >
            Login as {roles.find(r => r.value === selectedRole)?.label}
          </button>

          <div className="text-center">
            <p className="text-sm text-gray-500">
              Password: Admin@123 for all users
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
